var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPayBills = function SvgPayBills(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "pay_bills")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-10.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_bill_1090617_000000",
    transform: "translate(11.666667, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8383549,8.64031123e-05 L10.8198276,4.29880679 C10.8174473,4.85108641 11.2632288,5.30072712 11.8155084,5.30310742 C11.8169451,5.30311361 11.8183817,5.30311671 11.8198183,5.30311671 L16.4882379,5.30311671 L16.4882379,5.30311671 C16.8650791,5.25013877 16.6450044,4.75417543 15.8280138,3.8152267 C15.0110232,2.87627796 13.6930212,1.60456453 11.8740076,8.64031123e-05 L10.8383549,8.64031123e-05 Z",
    id: "Path",
    fill: "#232323",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666667,3.77657513 L16.6666667,20.6449725 C16.6666667,21.2091066 16.1779576,21.6666667 15.5754193,21.6666667 L1.0912474,21.6666667 C0.488709047,21.6666667 0,21.2091066 0,20.6449725 L0,1.02169418 C0,0.457560025 0.488709047,0 1.0912474,0 L12.2079571,0 L16.6666667,3.77657513 Z",
    id: "Path",
    stroke: "#232323",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 7.916667)",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.11888396,
    y1: 9.16666667,
    x2: 6.59982788,
    y2: 9.16666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.833333333,
    x2: 6.66635,
    y2: 0.833333333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.66634938,
    y1: 5,
    x2: -6.22414646e-7,
    y2: 5,
    id: "Path"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayBills, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pay_bills.701830dd.svg";
export { ForwardRef as ReactComponent };